import ExportIcon from '@mui/icons-material/Description'
import { Link as L } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import authStore from '../auth/authStore'
import { i18n } from '../index/index'
import { ExportLink, Widget, WidgetContent, WidgetHeader } from './OldDashboardComponents'
import css from './feelingsMeter.css'
type Props = {
  feeling: number
  count: number
  date: string
}

const FeelingsMeter = observer(({ feeling, count, date }: Props) => (
  <Widget>
    <WidgetHeader>
      <L underline='always' component={Link} to={`/tyontekijakortti/fiilismittari/${date}`} color='inherit'>
        {i18n.t('oldDashboard.widget.feelingMeter.title')}
      </L>
    </WidgetHeader>
    <WidgetContent>
      <div className={css.face}>
        <img src={`feeling-${Math.round(feeling)}.svg`} alt='' />
      </div>
      <p className={css.number}>{Math.round(feeling * 10) / 10 || '-'} / 5</p>
      <p className={css.feelings}>
        {i18n.t('oldDashboard.widget.feelingMeter.feelingsCount')}: {count}
      </p>
    </WidgetContent>
    {authStore.userHasPermission('nav_admin') && (
      <ExportLink to={`/raportointi/fiilismittaripalautteet`}>
        <ExportIcon />
      </ExportLink>
    )}
  </Widget>
))

export default FeelingsMeter
